"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fields = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['password', 'repeatPassword', 'termsandconds'];
var validate = function validate(values, props) {
  var errors = {};
  if (!values.password) {
    errors.password = 'Password is required';
  } else if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'The passwords must match';
  }
  if (!values.termsandconds) {
    errors.termsandconds = 'The privacy policy and terms of use must be accepted to continue';
  }
  return errors;
};
var Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    _classCallCheck(this, Form);
    return _callSuper(this, Form, arguments);
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$fields = _this$props.fields,
        password = _this$props$fields.password,
        repeatPassword = _this$props$fields.repeatPassword,
        termsandconds = _this$props$fields.termsandconds,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        username = _this$props.username,
        fullName = _this$props.fullName,
        renderTermsAndConds = _this$props.renderTermsAndConds;
      var cccisdPrivacyPolicyUrl = 'https://www.3cisd.com/privacy-policy?page_id=3110';
      var cccisdTermsOfUseUrl = 'http://www.3cisd.com/terms-of-use';
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("h3", null, "Welcome, ", fullName || username, "!"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card",
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-header"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: '20px'
        }
      }, "Create a password for your account with username ", /*#__PURE__*/_react["default"].createElement("strong", null, username))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          maxWidth: '350px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: password,
        label: "Create Password",
        type: "password"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          maxWidth: '350px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        field: repeatPassword,
        label: "Confirm Password",
        type: "password"
      })))), renderTermsAndConds ? renderTermsAndConds({
        cccisdPrivacyPolicyUrl: cccisdPrivacyPolicyUrl,
        cccisdTermsOfUseUrl: cccisdTermsOfUseUrl,
        field: termsandconds
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "card",
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-header"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: '20px',
          fontWeight: 'bold'
        }
      }, "3C Privacy Policy and Terms of Use")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].terms
      }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: cccisdPrivacyPolicyUrl,
        target: "blank"
      }, "Privacy Policy")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: cccisdTermsOfUseUrl,
        target: "blank"
      }, "Terms of Use"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "card-footer"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: termsandconds
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox form-check"
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox",
        className: "form-check-input"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(termsandconds))), /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-check-label"
      }, "I accept the privacy policy and terms of use."))))), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        title: "Activate",
        isLoading: submitting,
        onClick: handleSubmit
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  username: _propTypes["default"].string,
  fullName: _propTypes["default"].string,
  renderTermsAndConds: _propTypes["default"].func
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  fields: fields,
  initialValues: {
    password: '',
    repeatPassword: '',
    termsandconds: false
  },
  validate: validate
})(Form);